import React, { memo } from 'react'
const TopBanner = ({ showReviewBanner, mainText, subText, fareDataForTop }) => {
  return showReviewBanner || (mainText === 'birthday') || (mainText === 'cws') || (fareDataForTop || !fareDataForTop) ? (
    <p className='col-sm-12 top_banner'>
      {showReviewBanner
        ? 'Review and Search'
        : (mainText === 'birthday') ? (
          <>
            {`Happy Birthday ${subText}`}
            {subText && (
              <span style={{ paddingTop: mainText ? '10px' : '' }}>
                {`Treat yourself to the trip of your dreams! Limited time exclusive offer for you and your friends & family.`}
              </span>
            )}
          </>
        ) :

          mainText === 'cws' ? (
            <>
              {`Cyber Week Sale`}
              <span style={{ paddingTop: '10px' }}>
                {`Now's the time to take a byte! Limited time only.`}
              </span>
            </>
          ) :

            (
              <>
                {`UP TO 37% OFF*`}
                {fareDataForTop && <span style={{ paddingTop: '10px' }}>
                  {`Flight Deals from ${fareDataForTop.from.cityName} starting at $${fareDataForTop.fare_detail.fare}*`}
                </span>}
              </>
            )
      }
    </p>
  ) : null
}

export default memo(TopBanner)